import _ from 'lodash';
import SyncableModel from './SyncableModel';
import Farm from './Farm';
import { getRootStore } from "../utils/root-store"
import { Platform } from "react-native"

export default class User extends SyncableModel {
    static name = 'User'

    _fillable = [
      'id',
      'id_number',
      'id_scan',
      'tin_number',
      'tin_scan',
      'family_card_number',
      'family_card_scan',
      'name',
      'avatar',
      'email',
      'email_verified',
      'unsubscribe_email_at',
      'phone_country',
      'phone',
      'phone_verified',
      'password',
      'birthdate',
      'gender',
      'country',
      'occupation',
      'company',
      'company_address',
      'position',
      'monthly_income',
      'income_source',
      'last_login_at',
      'deactivated',
      'expired_at',
      'buyer',
      'allow_create_client',
      'allow_create_token',
      'interest',
      'interests',
      'state',
      'remember_token',
      'created_at',
      'updated_at',
      'role_id',
      'settings',
      'region_id',
      'address',
      'subscription_type_id',
      'freshchat_restore_id',
      'telegram_id',
      'synced_at',
      'deleted_at',
    ]

    _attributes = {
      password: 'secret'
    }

    _casts = {
      email_verified: 'boolean',
      phone_verified: 'boolean',
      buyer: 'boolean',
      allow_create_client: 'boolean',
      allow_create_token: 'boolean',
      interests: 'array',
      state: 'object',
      settings: 'object',
    }

    static endpoint = '/users'

    // Handling cycle dependencies
    static FarmUser = SyncableModel

    setRegionIdAttribute(value) {
      this._attributes = {
        ...this._attributes,
        region_id: value ? value.substring(0, 7) : value
      };
      return this;
    }

  static async fetch(params = {}) {
    const { userStore: { user } } = getRootStore();
    const _params = { ...params };
    if (user && user.role_id === 1 && !_params.id__in && Platform.OS === 'web') {
      const farmUsers = await this.createAxios().get(this.FarmUser.endpoint, {
        params: {
          farm_id__in: (await Farm.query().get()).map((farm) => farm.getKey()).join(','),
          per_page: 1000
        }
      }).then((response) => response.data.data);
      const userIds = _.uniq(farmUsers.map((farmUser) => farmUser.user_id));
      _params.id__in = userIds.join(',');
    }
    return super.fetch(_params);
  }

    static async syncAll(
      params = {}, sqlParams = [], cleanAfterSync = true,
      onSyncProgressUpdate = undefined, onError = undefined
    ) {
      const { userStore: { user } } = getRootStore();
      const _params = { ...params };
      const _sqlParams = [...sqlParams];
      if (user && user.role_id === 1 && !_params.id__in) {
        const farmUsers = await this.createAxios().get(this.FarmUser.endpoint, {
          params: {
            farm_id__in: (await Farm.query().get()).map((farm) => farm.getKey()).join(','),
            per_page: 1000
          }
        }).then((response) => response.data.data);
        const userIds = _.uniq(farmUsers.map((farmUser) => farmUser.user_id));
        _params.id__in = userIds.join(',');
        _sqlParams.push(['users.id', userIds]);
      }
      return super.syncAll(_params, _sqlParams, cleanAfterSync, onSyncProgressUpdate, onError);
    }
}
